/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.1
 */

export enum ESkeletonKind {
    BUTTON_ROUND = 'buttonRound',
    CHART_DONUT = 'chartDonut',
    PARAGRAPH_NORMAL = 'paragraphNormal',
    PARAGRAPH_SMALL = 'paragraphSmall',
}

export interface ISkeletonStyled {
    kind: ESkeletonKind;
}
